<script>
import ManageItem from '@/pages/manage/_type/_id/index.vue'
import OptionsDisplay from '@/components/OptionsDisplay.vue'
import { http } from '@/services/http.js'

export default {
  name: 'ManageStatusTransition',
  components: {
    OptionsDisplayApi: OptionsDisplay,
    DeleteButton: {render() {}},
    EditButton: {render() {}},
  },
  extends: ManageItem,
  props: {
    token: String,
    stsToken: String,
    getItem: {
      type: Function,
      default() {
        return http.get(`/api/artist-identity/${this.token}/${this.type}/${this.id}/status-transitions/${this.stsToken}/`)
          .then(response => response.data)
      },
    },
  },
}
</script>
